import { IClock } from 'protos'

const formatMatchMinute = (clock?: (IClock|null)) => {
  if (clock && clock.minute) {
    let content: string = `${+clock.minute}'`

    if (clock.extra) {
      content += ` +${clock.extra}`
    }

    return content
  }

  return '0\''
}

export default formatMatchMinute
try {
    // @ts-ignore
    formatMatchMinute.displayName = "formatMatchMinute";
    // @ts-ignore
    formatMatchMinute.__docgenInfo = { "description": "", "displayName": "formatMatchMinute", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/lib/formatMatchMinute.ts#formatMatchMinute"] = { docgenInfo: formatMatchMinute.__docgenInfo, name: "formatMatchMinute", path: "src/lib/formatMatchMinute.ts#formatMatchMinute" };
}
catch (__react_docgen_typescript_loader_error) { }